module.exports = __webpack_public_path__ + "img/card-hand-credit-meter.6f3c27f.jpg";